
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ApplicationsTab from '@/components/admin/ApplicationsTab';
import CodesTab from '@/components/admin/CodesTab';
import UsersTab from '@/components/admin/UsersTab';
import ErrorsTab from '@/components/admin/ErrorsTab';
import StatsTab from '@/components/admin/StatsTab';
import TestEmailsTab from '@/components/admin/TestEmailsTab';

const BetaAdmin: React.FC = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [activeTab, setActiveTab] = useState<string>('applications');

  // Check if user is admin, if not, redirect to home
  useEffect(() => {
    if (user && !isAdmin) {
      toast({
        title: 'Zugriff verweigert',
        description: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
        variant: 'destructive',
      });
      navigate('/');
    }
    
    // For debugging - check admin status
    console.log('BetaAdmin component rendered, isAdmin:', isAdmin, 'user:', user?.id);
  }, [user, isAdmin, navigate, toast]);

  return (
    <div className="container mx-auto py-10">
      <h1 className="text-3xl font-bold mb-6 text-white">Admin Dashboard</h1>
      
      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v)}>
        <TabsList className="mb-6">
          <TabsTrigger value="applications">Beta-Bewerbungen</TabsTrigger>
          <TabsTrigger value="codes">Einladungscodes</TabsTrigger>
          <TabsTrigger value="users">Benutzer</TabsTrigger>
          <TabsTrigger value="errors">Fehler</TabsTrigger>
          <TabsTrigger value="stats">Statistiken</TabsTrigger>
          <TabsTrigger value="test-emails">E-Mail-Tests</TabsTrigger>
        </TabsList>
        
        <TabsContent value="applications">
          <ApplicationsTab />
        </TabsContent>
        
        <TabsContent value="codes">
          <CodesTab />
        </TabsContent>
        
        <TabsContent value="users">
          <UsersTab />
        </TabsContent>
        
        <TabsContent value="errors">
          <ErrorsTab />
        </TabsContent>
        
        <TabsContent value="stats">
          <StatsTab />
        </TabsContent>

        <TabsContent value="test-emails">
          <TestEmailsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default BetaAdmin;
